import { api, getDeviceId } from './api';

/** Aluno menor de idade sob a responsabilidade de quem entrou, ainda sem aceite. */
export interface TuteladoConsentPendente {
  aluno_pessoa_id: string;
  aluno_nome: string;
}

export interface ConsentPendente {
  precisa_aceitar: boolean;
  versao_atual: string;
  ultima_versao_aceita: string | null;
  eh_menor: boolean;
  pode_autoconsentir: boolean;
  texto_termo: string;
  /**
   * Tutelados menores sem aceite da versão vigente. Eles não podem consentir
   * por si (o POST deles recebe 403), então quem aceita é o responsável, em
   * /consent-lgpd/tutelado; sem isso ficariam presos no termo para sempre.
   * Vazio para quem não é responsável.
   */
  tutelados_pendentes: TuteladoConsentPendente[];
}

export interface ConsentRegistro {
  id: number;
  pessoa_id: string;
  versao_termo: string;
  aceito: boolean;
  device_id: string | null;
  registrado_em: string;
}

interface RespostaSucesso<T> {
  success: true;
  data: T;
}

/**
 * Nada a aceitar: nem pela própria pessoa, nem pelos tutelados menores dela.
 * O responsável só passa depois de aceitar por eles também, porque o aluno
 * menor não tem outro caminho para passar do termo. Mesma regra do app.
 */
export function pendenciaResolvida(p: ConsentPendente): boolean {
  return !p.precisa_aceitar && p.tutelados_pendentes.length === 0;
}

export const consentLgpdServico = {
  async pendente(): Promise<ConsentPendente> {
    const r = await api.get<RespostaSucesso<ConsentPendente>>('/consent-lgpd/pendente');
    // Backend anterior à lista de tutelados não manda o campo.
    return { ...r.data.data, tutelados_pendentes: r.data.data.tutelados_pendentes ?? [] };
  },

  // Os registros levam o id deste navegador (o mesmo do X-Device-Id), para a
  // trilha de auditoria dizer de onde veio o aceite; o backend só o lê do corpo.
  async registrar(versao: string, aceito: boolean): Promise<ConsentRegistro> {
    const r = await api.post<RespostaSucesso<ConsentRegistro>>('/consent-lgpd', {
      versao_termo: versao,
      aceito,
      device_id: getDeviceId(),
    });
    return r.data.data;
  },

  async registrarParaTutelado(
    alunoPessoaId: string,
    versao: string,
    aceito: boolean
  ): Promise<ConsentRegistro> {
    const r = await api.post<RespostaSucesso<ConsentRegistro>>('/consent-lgpd/tutelado', {
      aluno_pessoa_id: alunoPessoaId,
      versao_termo: versao,
      aceito,
      device_id: getDeviceId(),
    });
    return r.data.data;
  },
};
